import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from './auth/auth.module';
import {AuditListModule} from './audits/audit-list/audit-list.module';

@NgModule({
  imports: [
    CommonModule,
    AuthModule,
    AuditListModule
  ],
  declarations: []
})
export class PagesModule { }



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/pages.module.ts